import { useQueries, useQuery } from '@tanstack/react-query';
import { IComponents } from 'gcf-components/interfaces';
import {
  IConfigs,
  IContents,
  ILocationData,
  ILocationFileVersion,
  ILocations,
} from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export interface ISplittedLocationData {
  contents: IContents;
  products: any;
  assets: any;
  overrides: any;
  configs: IConfigs;
  dayparts: any;
  location: ILocations;
  components?: Record<string, IComponents>;
  templates?: any;
  ['template-variations']?: any;
}

/** @deprecated For legacy cc publication v1 */
export const useGetFullLocationData = (
  locationCode: string,
  versionId: string,
  enabled = true,
) => {
  const filters = [`location_code=${locationCode}`, `version_id=${versionId}`];

  return useQuery({
    queryKey: queryKeys.locationDataVersion.details(filters),
    queryFn: () => fetchLocationData(filters) as Promise<ILocationData>,
    enabled: enabled,
  });
};

const fetchLocationData = async (filters: string[] = []) => {
  const query = generateQuery([], filters);

  const url = `/locationDataVersion${query}`;

  const response = await requestCCApi({ url });

  return response;
};

export const useGetSplittedLocationData = (
  locationCode: string,
  versions: ILocationFileVersion[] = [],
  enabled = true,
) => {
  const locationDataQueries = useQueries({
    queries: versions.map((version) => {
      const filters = [
        `location_code=${locationCode}`,
        `version_id=${version.version_id}`,
        `type=${version.type}`,
      ];

      return {
        queryKey: queryKeys.locationDataVersion.details(filters),
        queryFn: () => fetchLocationData(filters),
        enabled,
      };
    }),
  });

  return {
    isLoading: locationDataQueries.some((query) => query.isLoading),
    isFetching: locationDataQueries.some((query) => query.isFetching),
    isSuccess: locationDataQueries.every((query) => query.isSuccess),
    data: locationDataQueries.reduce(
      (acc, query, index) => ({
        ...acc,
        [versions[index].type]: query.data,
      }),
      {},
    ) as ISplittedLocationData,
  };
};
